import React, { useState, useEffect, useMemo } from "react";
import Base from "../../Config/Base";

import Pagination from "../../Config/Pagination";
import "../../../Assets/popup.css";
import "jspdf-autotable";
import "../../Config/loading.css";
import { Link, useNavigate } from "react-router-dom";
import { useLabelContext } from "../../../Context";
import { API_BASE_URL } from "../../Config/Config";
import { Footer } from "../footer/footer";

export default function PendingIndent() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [storeData, setStoreData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [dashboardData, SetDashboardData] = useState([]);
  const [MisUserDetails, SetUserDetails] = useState([]);
  const { setID } = useLabelContext();

  useEffect(() => {
    const MisUserDetailsSession = JSON.parse(
      sessionStorage.getItem("MisUserDetails") ||
        localStorage.getItem("MisUserDetails")
    );
    SetUserDetails(MisUserDetailsSession);
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${API_BASE_URL}Dashboard/InventoryDashboard?OrgId=${MisUserDetails.OrgId}&StoreId=${MisUserDetails.StoreId}&UserId=${MisUserDetails.UserId}`
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        console.log(data.pendingIndents);
        console.log(data);

        if (data && Object.keys(data).length > 0) {
          SetDashboardData(data.pendingIndents);
        } else {
          console.error("Fetched data is not as expected:", data);
          SetDashboardData([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (MisUserDetails?.OrgId) {
      fetchData();
    }
  }, [MisUserDetails]);

  const handleReload = () => {
    window.location.reload();
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // const filteredItems = expensesData.filter(
  //   (item) =>
  //     (item.proj_name &&
  //       item.proj_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
  //     (item.category_name &&
  //       item.category_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
  //     (item.expense_name &&
  //       item.expense_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
  //     (item.cus_name &&
  //       item.cus_name.toLowerCase().includes(searchTerm.toLowerCase()))
  // );

  const filteredItems = useMemo(() => {
    const results = dashboardData.filter(
      (item) =>
        item.StoreName &&
        item.StoreName.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setCurrentPage(1);
    return results;
  }, [dashboardData, searchTerm]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    console.log(dashboardData);
  });

  return (
    <Base>
      <div className="page-header">
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <div className="page-title me-2">
            <h4>Pending Indent</h4>
            <h6>Manage Pending Indents</h6>
          </div>
          <div className="search-bar mb-3 ">
            <div className="input-group">
              <input
                type="text"
                name="search..........."
                placeholder="Search..."
                className="form-control"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="card-container mb-0" style={{ marginTop: "-20px" }}>
        {loading ? (
          <div className="text-center my-5">
            <div className="containers m-auto d-flex justify-content-center align-items-center">
              <div className="dot bg-primary"></div>
              <div className="dot bg-secondary"></div>
              <div className="dot bg-success"></div>
              <div className="dot bg-danger"></div>
              <div className="dot bg-warning"></div>
              <div className="dot bg-info"></div>
            </div>
            <p>Loading...</p>
          </div>
        ) : (
          <div className="row">
            {currentItems &&
              currentItems.map((item, index) => (
                <div
                  key={index}
                  className="col-md-6"
                  style={{ marginTop: "-20px" }}
                >
                  <div
                    className="store-card card shadow-sm my-3"
                    style={{
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      padding: "1px",
                    }}
                  >
                    <div className="card-body">
                      <h5 className="card-title d-flex align-items-center mb-3">
                        <i
                          className="fa-solid fa-shop"
                          style={{ marginRight: "5px", color: "#007bff" }}
                        ></i>{" "}
                        {item.StoreName}
                      </h5>
                      <div className="card-details">
                        <div
                          className="row"
                          style={{ color: "#6c757d", marginTop: "10px" }}
                        >
                          <div className="col-6">
                            <span>
                              <strong>
                                <i
                                  className="fa-solid fa-indent me-2"
                                  style={{ color: "#007bff" }}
                                ></i>
                              </strong>{" "}
                              {item.IndentNo}
                            </span>
                          </div>
                          <div className="col-6">
                            <span>
                              <strong>
                                <i
                                  className="fa-solid fa-calendar-days me-2"
                                  style={{ color: "#007bff" }}
                                ></i>
                              </strong>{" "}
                              {formatDate(item.IndentDt)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        )}
        <Pagination
          itemsPerPage={itemsPerPage}
          totalItems={dashboardData.length}
          paginate={paginate}
          currentPage={currentPage}
        />
      </div>
      <br />
      <br />
      <br />

      <Footer></Footer>
    </Base>
  );
}
